(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nidol-custom-order"]) return;
  try {
    
if (!customElements.get('nidol-cap-order')) {
  customElements.define('nidol-cap-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const form = this.querySelector('form');
      const data = this.querySelector('[data-order-data]');
      if (!form || !data) return;
      this.initialized = true;
      const variants = JSON.parse(data.textContent);
      const select = this.querySelector('[data-order-variant]');
      const file = this.querySelector('[data-order-file]');
      const text = this.querySelector('[data-order-text]');
      const button = this.querySelector('[data-order-submit]');
      const error = this.querySelector('[data-order-error]');
      const preview = this.querySelector('[data-file-preview]');
      const status = this.querySelector('[data-file-status]');
      const upload = this.querySelector('.nd-order__upload');
      const uploadName = this.querySelector('[data-upload-name]');
      const uploadAction = this.querySelector('[data-upload-action]');
      const uploadIcon = this.querySelector('[data-upload-icon]');
      const notes = this.querySelector('[data-order-notes]');
      const notesStatus = this.querySelector('[data-notes-status]');
      const updateNotes = () => { notesStatus.textContent = notes.value.trim() ? notesStatus.dataset.added : notesStatus.dataset.empty; };
      notes.addEventListener('input', updateNotes);
      updateNotes();
      const groups = Array.from(this.querySelectorAll('[data-option-index]'));
      const productImage = this.querySelector('.nd-order__image img');
      let objectUrl;
      const update = () => {
        groups.slice(1).forEach(group => {
          const optionIndex = Number(group.dataset.optionIndex);
          const previousOptions = groups.slice(0, optionIndex).map(previous => previous.querySelector('input:checked')?.value);
          const inputs = Array.from(group.querySelectorAll('input[type="radio"]'));
          inputs.forEach(input => {
            const exists = variants.some(item => item.options[optionIndex] === input.value && previousOptions.every((value, i) => item.options[i] === value));
            input.disabled = !exists;
            input.closest('label').hidden = !exists;
            if (!exists) input.checked = false;
          });
          if (!group.querySelector('input:checked')) {
            const first = inputs.find(input => !input.disabled);
            if (first) first.checked = true;
          }
        });
        const options = groups.map(group => {
          const value = group.querySelector('input:checked')?.value;
          group.querySelector('[data-selected-value]').textContent = value || '';
          return value;
        });
        const variant = variants.find(item => item.options.every((value, i) => value === options[i]));
        button.disabled = !variant?.available;
        button.textContent = variant?.available ? button.dataset.addLabel : button.dataset.unavailableLabel;
        if (!variant) { select.value = ''; return; }
        select.value = String(variant.id);
        this.querySelector('[data-image-warning]').hidden = variant.exact_image;
        this.querySelector('[data-fit-style]').textContent = variant.options[0];
        this.querySelector('[data-order-price]').textContent = variant.price;
        const comparePrice = this.querySelector('[data-order-compare]');
        comparePrice.hidden = !variant.compare_at_price;
        comparePrice.textContent = variant.compare_at_price || '';
        comparePrice.setAttribute('aria-label', comparePrice.dataset.orderCompareLabel + ': ' + (variant.compare_at_price || ''));
        if (productImage && variant.image) {
          productImage.srcset = variant.image.srcset;
          productImage.src = variant.image.src;
          productImage.alt = variant.image.alt;
        }
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url);
      };
      groups.forEach(group => group.addEventListener('change', update));
      window.addEventListener('pageshow', () => { update(); this.removeAttribute('aria-busy'); });
      this.querySelector('[data-order-options]').hidden = false;
      this.querySelector('[data-variant-fallback]').hidden = true;
      update();
      const fail = message => { error.textContent = message; error.hidden = false; };
      const validateArtwork = () => {
        const artwork = file.files[0];
        let message = '';
        if (artwork && artwork.size > 10 * 1024 * 1024) message = error.dataset.large;
        else if (artwork && (!/\.(png|jpe?g|pdf)$/i.test(artwork.name) || (artwork.type && !/^(image\/(png|jpeg)|application\/pdf)$/.test(artwork.type)))) message = error.dataset.type;
        file.setCustomValidity(message);
        if (message) fail(message);
        return !message;
      };
      form.addEventListener('invalid', event => {
        if (event.target === file) fail(file.validationMessage || error.dataset.missing);
      }, true);
      window.addEventListener('pageshow', () => { validateArtwork(); });

      file.addEventListener('change', () => {
        error.hidden = true;
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        preview.hidden = true;
        const artwork = file.files[0];
        const validArtwork = validateArtwork();
        status.textContent = artwork ? artwork.name : '';
        upload.classList.toggle('has-file', !!artwork);
        uploadName.textContent = artwork ? artwork.name : uploadName.dataset.empty;
        uploadAction.textContent = artwork ? uploadAction.dataset.selected : uploadAction.dataset.empty;
        uploadIcon.removeAttribute('hidden');
        if (validArtwork && artwork && /^image\/(png|jpeg)$/.test(artwork.type)) {
          objectUrl = URL.createObjectURL(artwork);
          preview.src = objectUrl;
          preview.hidden = false;
          uploadIcon.setAttribute('hidden', '');
        }
      });
      form.addEventListener('submit', event => {
        error.hidden = true;
        const artwork = file.files[0];
        if (!artwork && !text.value.trim()) { event.preventDefault(); fail(error.dataset.missing); file.focus(); return; }
        if (artwork && artwork.size > 10 * 1024 * 1024) { event.preventDefault(); fail(error.dataset.large); file.focus(); return; }
        if (!validateArtwork()) { event.preventDefault(); file.focus(); return; }
        if (artwork && !/\.(png|jpe?g|pdf)$/i.test(artwork.name)) { event.preventDefault(); fail(error.dataset.type); file.focus(); return; }
        if (!variants.find(variant => String(variant.id) === select.value)?.available) { event.preventDefault(); fail(button.dataset.unavailableLabel); return; }
        button.disabled = true;
        this.setAttribute('aria-busy', 'true');
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nidol-motion-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nidol-motion-call')) {
    customElements.define('nidol-motion-call', class extends HTMLElement {
      connectedCallback() {
        this.words = Array.from(this.querySelectorAll('[data-motion-word]'));
        this.tabs = Array.from(this.querySelectorAll('[data-motion-select]'));
        this.pauseButton = this.querySelector('[data-motion-pause]');
        this.index = 0;
        this.paused = false;
        this.visible = false;
        this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.tabs.forEach((tab, index) => tab.addEventListener('click', () => {
          this.select(index);
          this.sync();
        }, options));
        this.pauseButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.pauseButton.setAttribute('aria-pressed', String(this.paused));
          this.pauseButton.setAttribute('aria-label', this.pauseButton.dataset[this.paused ? 'playLabel' : 'pauseLabel']);
          this.sync();
        }, options);
        this.addEventListener('focusin', () => this.sync(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.sync()), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.media.addEventListener('change', () => this.sync(), options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: .2 });
        this.observer.observe(this);
        this.pauseButton.hidden = this.dataset.enabled !== 'true' || this.media.matches;
      }
      select(index) {
        this.index = index;
        this.words.forEach((word, i) => word.classList.toggle('is-current', i === index));
        this.tabs.forEach((tab, i) => tab.setAttribute('aria-pressed', String(i === index)));
      }
      sync() {
        clearTimeout(this.timer);
        const enabled = this.dataset.enabled === 'true' && !this.media.matches;
        this.pauseButton.hidden = !enabled;
        const running = enabled && this.visible && !this.paused && !document.hidden && !this.contains(document.activeElement);
        this.dataset.moving = String(running);
        if (running) this.timer = setTimeout(() => {
          this.select((this.index + 1) % this.words.length);
          this.sync();
        }, 4200);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort.abort();
        this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nidol-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('nidol-newsletter-popup')) {
    class NidolNewsletterPopup extends HTMLElement {
      static selectedSectionId = null;

      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        if (!this.dialog || !this.form || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        this.options = { signal: this.controller.signal };
        this.editor = this.dataset.editor === 'true';
        this.storageKey = `nidol-newsletter-v2:${this.dataset.themeId}:${this.dataset.eligible === 'true' ? 'eligible' : 'visitor'}`;
        this.elapsedKey = `${this.storageKey}:elapsed`;
        this.pendingKey = `${this.storageKey}:pending`;
        this.delay = Math.max(0, Number(this.dataset.delay) || 15000);
        this.elapsed = Math.max(0, Number(this.read('sessionStorage', this.elapsedKey)) || 0);
        this.startedAt = null;
        this.formResult = this.querySelector('[data-newsletter-result]').dataset.newsletterResult;
        this.querySelector('[data-newsletter-close]').addEventListener('click', () => this.dismiss(), this.options);
        this.querySelector('[data-newsletter-preview]')?.addEventListener('click', () => this.show(true), this.options);
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, this.options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dismiss();
        }, this.options);
        this.dialog.addEventListener('close', () => this.releaseScroll(), this.options);
        this.form.addEventListener('submit', event => {
          if (this.editor) { event.preventDefault(); return; }
          this.write('sessionStorage', this.pendingKey, String(Date.now()));
        }, this.options);
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          NidolNewsletterPopup.selectedSectionId = this.dataset.sectionId;
          this.show(true);
        }, this.options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          NidolNewsletterPopup.selectedSectionId = null;
          this.close();
        }, this.options);
        document.addEventListener('shopify:section:unload', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.disconnectedCallback();
        }, this.options);
        if (this.editor) {
          if (NidolNewsletterPopup.selectedSectionId === this.dataset.sectionId) this.show(true);
          return;
        }
        const pendingAt = Number(this.read('sessionStorage', this.pendingKey));
        const responseIsOurs = location.hash === `#${this.form.id}` || (pendingAt > 0 && Date.now() - pendingAt < 900000);
        if (this.formResult === 'success') {
          this.remember('subscribed');
          this.write('sessionStorage', this.pendingKey, '');
          if (responseIsOurs) this.show(true);
          return;
        }
        if (this.formResult === 'error' && responseIsOurs) {
          this.write('sessionStorage', this.pendingKey, '');
          this.show(true);
          return;
        }
        if (this.dataset.returning === 'true') return;
        if (this.dataset.subscribed === 'true' && this.dataset.eligible !== 'true') { this.remember('subscribed'); return; }
        if (this.dataset.enabled !== 'true' || this.suppressed()) return;
        document.addEventListener('visibilitychange', () => document.hidden ? this.pause() : this.schedule(), this.options);
        window.addEventListener('pagehide', () => this.pause(), this.options);
        window.addEventListener('pageshow', () => this.schedule(), this.options);
        window.addEventListener('storage', event => {
          if (event.key === this.storageKey && event.newValue) { this.pause(); this.close(); }
        }, this.options);
        this.schedule();
      }

      read(storage, key) {
        try { return window[storage].getItem(key); } catch { return null; }
      }

      write(storage, key, value) {
        try { window[storage].setItem(key, value); } catch { }
      }

      suppressed() {
        return this.dismissed || this.read('localStorage', this.storageKey) || this.read('sessionStorage', this.storageKey);
      }

      remember(value) {
        this.dismissed = true;
        if (!this.editor) {
          this.write('localStorage', this.storageKey, value);
          this.write('sessionStorage', this.storageKey, value);
        }
      }

      pause() {
        clearTimeout(this.timer);
        if (this.startedAt !== null) {
          this.elapsed += performance.now() - this.startedAt;
          this.startedAt = null;
          this.write('sessionStorage', this.elapsedKey, String(Math.min(this.elapsed, this.delay)));
        }
      }

      schedule() {
        this.pause();
        if (this.editor || document.hidden || this.suppressed() || this.dialog.open) return;
        this.elapsed = Math.max(this.elapsed, Number(this.read('sessionStorage', this.elapsedKey)) || 0);
        this.startedAt = performance.now();
        this.timer = setTimeout(() => {
          this.pause();
          if (document.hidden || this.suppressed()) return;
          const focusedField = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
          const otherDialog = Array.from(document.querySelectorAll('dialog[open]')).some(dialog => dialog !== this.dialog);
          if (focusedField || otherDialog) {
            this.timer = setTimeout(() => this.schedule(), 1000);
            return;
          }
          this.show();
        }, Math.max(0, this.delay - this.elapsed));
      }

      show(force = false) {
        if (!this.isConnected || this.dialog.open || (!force && this.suppressed())) return;
        this.pause();
        this.previouslyFocused = document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('nd-newsletter-is-open');
        const focusTarget = this.querySelector('.nd-newsletter-success, .nd-newsletter-error') || this.querySelector('[data-newsletter-close]');
        focusTarget?.focus({ preventScroll: true });
      }

      dismiss() {
        if (!this.editor) this.remember('dismissed');
        this.pause();
        this.close();
      }

      close() {
        if (this.dialog?.open) this.dialog.close();
        this.releaseScroll();
        if (this.previouslyFocused?.isConnected) this.previouslyFocused.focus({ preventScroll: true });
      }

      releaseScroll() {
        if (!document.querySelector('nidol-newsletter-popup dialog[open]')) document.documentElement.classList.remove('nd-newsletter-is-open');
      }

      disconnectedCallback() {
        if (!this.controller) return;
        this.pause();
        this.close();
        this.controller.abort();
        this.controller = null;
      }
    }
    customElements.define('nidol-newsletter-popup', NidolNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nidol-original-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nidol-design-viewer')) {
  class NidolDesignViewer extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('[data-design-image]');
      this.photo = this.image?.querySelector('img');
      if (!this.photo || this.onViewClick) return;
      this.buttons = [...this.querySelectorAll('[data-design-view]')];
      this.fullSizes = this.photo.sizes;
      this.onViewClick = event => {
        const button = event.target.closest('[data-design-view]');
        if (button && this.contains(button)) this.setView(button.dataset.designView);
      };
      this.addEventListener('click', this.onViewClick);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const main = document.querySelector('product-info[data-product-id="' + this.dataset.productId + '"]');
          if (!main || event.data.sectionId !== main.dataset.section) return;
          const media = event.data.variant?.featured_media;
          const source = media?.preview_image?.src || media?.preview_image?.url;
          this.image.classList.toggle('is-missing', !source);
          this.querySelector('[data-design-missing]').hidden = !!source;
          this.buttons.forEach(button => { button.disabled = !source; });
          if (!source) { this.setView('full'); return; }
          const url = new URL(source, window.location.origin);
          url.searchParams.set('width', '2400');
          this.photo.srcset = [600, 900, 1200, 1800, 2400].map(width => {
            const candidate = new URL(url);
            candidate.searchParams.set('width', String(width));
            return candidate.href + ' ' + width + 'w';
          }).join(', ');
          this.photo.src = url.href;
          this.photo.alt = media.alt || main.querySelector('h1')?.textContent.trim() || '';
        });
      }
    }
    setView(view) {
      const detail = view === 'detail';
      this.image.classList.toggle('is-detail', detail);
      this.photo.sizes = detail ? '(min-width: 990px) 113vw, 235vw' : this.fullSizes;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.designView === view)));
    }
    disconnectedCallback() {
      if (this.onViewClick) this.removeEventListener('click', this.onViewClick);
      this.unsubscribe?.();
      this.onViewClick = null;
    }
  }
  customElements.define('nidol-design-viewer', NidolDesignViewer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nidol-theme-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.enhanced) return;
    const nav = root.querySelector('.nd-story__tabs');
    const tabs = Array.from(nav.querySelectorAll('.nd-story__tab'));
    const panels = Array.from(root.querySelectorAll('.nd-story__panel'));
    if (!tabs.length) return;
    root.dataset.enhanced = 'true';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-orientation', 'vertical');
    const responsive = window.matchMedia('(max-width: 749px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const setOrientation = () => nav.setAttribute('aria-orientation', responsive.matches ? 'horizontal' : 'vertical');
    setOrientation();
    responsive.addEventListener('change', setOrientation);
    tabs.forEach((tab, i) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', tab.dataset.panel);
      tab.setAttribute('aria-selected', String(i === 0));
      tab.tabIndex = i === 0 ? 0 : -1;
    });
    panels.forEach(panel => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', panel.dataset.tab);
      panel.tabIndex = 0;
    });
    let transition;
    let requestedIndex = 0;
    const select = (index, focus = false) => {
      const selected = tabs[index];
      if (focus) selected.focus();
      if (index === requestedIndex) return;
      requestedIndex = index;
      const update = () => {
        if (index !== requestedIndex) return;
        tabs.forEach(tab => {
          const active = tab === selected;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== selected.dataset.panel; });
      };
      if (transition) transition.skipTransition();
      if (document.startViewTransition && !reduced.matches && !responsive.matches) {
        transition = document.startViewTransition(update);
        transition.ready.catch(() => {});
        transition.finished.catch(() => {});
      } else {
        update();
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        select(index);
      });
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;
        if (event.key === (responsive.matches ? 'ArrowRight' : 'ArrowDown')) target = (index + 1) % tabs.length;
        if (event.key === (responsive.matches ? 'ArrowLeft' : 'ArrowUp')) target = (index - 1 + tabs.length) % tabs.length;
        if (event.key === ' ' || event.key === 'Enter') target = index;
        if (target === undefined) return;
        event.preventDefault();
        select(target, true);
      });
    });
  };
  document.querySelectorAll('[data-nidol-story]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-nidol-story]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
